import {createStore, applyMiddleware, compose} from 'redux';
//import {createLogger} from 'redux-logger';
import reducers from './reducers';
import reduxReset from 'redux-reset';
//import hasDeveloperSwitch from '../common/js/lib/hasDeveloperSwitch';

//import {environment} from '../ENV';

const middlewares = [];

//if (environment !== 'production' || hasDeveloperSwitch()) {
//
//   const reduxLogger = createLogger({
//       collapsed: true,
//       stateTransformer: state => state.toJS(),
//       titleFormatter: function(action, time) {
//            const actionType = action.type;
//            return `Chat bubble button: ${actionType} @ ${time}`
//       }
//    });
//
//    middlewares.push(reduxLogger);
//}


const enhanceCreateStore = compose(
    applyMiddleware(...middlewares),
    reduxReset()  // Will use 'RESET' as default action.type to trigger reset
  )(createStore);

const store = enhanceCreateStore(
    reducers,
     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// needs both formats
export default store;



// WEBPACK FOOTER //
// ./redux/store.js